import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _items: [],
};

export const mutations = {
  setItems(state, items) {
    state._items = [];
    state._items = items;
  },
};

export const actions = {
  async acReportRestore({}, body) {
    const url = `/api/v1/order/restore`;
    try {
      const res = await api.patch(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acSubscribeOrderMap({ commit }, subscribe_seq) {
    try {
      const url = `/api/v1/subscribe-order-map/subscribe?subscribe_seq=${subscribe_seq}`;
      const res = await api.get(url);

      console.log("acSubscribeOrderMap", res);
      return res.data.data;
    } catch (error) {
      console.log("acSubscribeOrderMap", error.response);
      return false;
    }
  },
  async acReportRollback({}, body) {
    const url = `/api/v1/order-cart/rollback`;
    try {
      await api.patch(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },

  async acOrderCancelList({ commit }, email) {
    const url = `/api/v1/order-cancel?email=${email}`;
    try {
      const result = await api.get(url);
      console.log(result.data);
      commit("setItems", result.data.items);
      return result.data;
    } catch (err) {
      console.log("err", err);
      return err.data;
    }
  },

  async acOrderCancel({ commit }, body) {
    const url = `/api/v1/order-cancel`;
    try {
      const result = await api.patch(url, body);
      console.log(result.data);
      return result.data;
    } catch (err) {
      console.log("err", err);
      return err.data;
    }
  },

  async acOrderCouponTicket({ commit }, payload) {
    const url = `/api/v1/order-ticket`;
    try {
      const result = await api.post(url, payload);
      console.log(result.data);
      return result.data?.code === 0 ? true : false;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  },

  async acRefundReportOrder({ commit }, orderSeq) {
    try {
      const url = `/api/v1/order/${orderSeq}/refund`;
      const res = await api.patch(url);
      return res.data?.code === 0;
    } catch (error) {
      console.error("[acRefundReportOrder] Error:", error);
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
